import PropTypes from 'prop-types'
import cn from 'classnames'
import { createUseStyles } from '../../helpers/createStyles'
import Column, { columnProps } from '../Column'
import Section from '../Section'
import { span, theme } from '../../styles/theme'

import useScrollTrigger from '../../hooks/useScrollTrigger'

const TwoColumnContent = ({
  data: { column1, column2, appearance = 'right' }
}) => {
  const styles = useStyles()

  const sectionRef = useScrollTrigger(
    () => ({
      trigger: sectionRef.current,
      start: () => `${window.innerHeight / 4}px bottom`,
      scrub: false
    }),
    (tl, ref) => {
      const defaults = {
        ease: 'power2.inOut',
        duration: 0.8
      }
      tl.from(ref.current.querySelectorAll(`.${styles.column}`), { y: 40, opacity: 0, stagger: 0.1, ...defaults })
    }
  )

  return (
    <Section grid className={styles.root} ref={sectionRef}>
      <Column
        column={column1}
        className={cn(styles.column, {
          [styles.alignRight]: appearance === 'right',
          [styles.widerColumn]: appearance === 'left',
          [styles.columnImage]: column1.contentType === 'image',
          'with-content': column1.contentType !== 'empty'
        })}
      />
      <Column column={column2} className={styles.column} />
    </Section>
  )
}

const useStyles = createUseStyles({
  root: {
    alignItems: 'start',
    [theme.breakpoints.down('xs')]: {
      rowGap: '0!important'
    }
  },
  column: {
    [theme.breakpoints.down('xs')]: {
      '&:first-child.with-content': {
        marginBottom: theme.section.marginBottom.sm
      }
    }
  },
  widerColumn: {
    [theme.breakpoints.up('md')]: {
      gridColumn: '1 / span 4!important',
      maxWidth: '80%'
    }
  },
  alignRight: {
    [theme.breakpoints.up('md')]: {
      gridColumnStart: '5!important'
    }
  },
  columnImage: {
    paddingRight: span(2, 'sm'),
    [theme.breakpoints.up('xs')]: {
      paddingRight: span(1, 'sm')
    },
    [theme.breakpoints.up('md')]: {
      paddingRight: span(1, 'md')
    }
  }
})

TwoColumnContent.propTypes = {
  data: PropTypes.shape({
    appearance: PropTypes.oneOf(['left', 'right']).isRequired,
    column1: PropTypes.shape(columnProps).isRequired,
    column2: PropTypes.shape(columnProps).isRequired
  }).isRequired,
  page: PropTypes.object.isRequired
}

export default TwoColumnContent
